export const gaTracking = (rest) => {
  if (typeof window.dataLayer === "undefined") {
    window.dataLayer = [];
  }
  window.dataLayer.push({ ...rest });
};
